const uploadStatusEnum = {
  INITIAL: "initial",
  DONE: "done",
  UPLOADING: "uploading",
  REMOVED: "removed",
};

export default uploadStatusEnum;
